<div class="content-container" *ngIf="isCommEnabled; else redirectInstruction">
  <nav class="navbar sticky-top">
    <div class="d-grid gap-2 d-flex navbar-brand w-100">
      <!-- Mobile Header -->
      <div class="row d-flex d-sm-none">
        <h2 class="mobileHeading col-6 ps-0">Communications</h2>
      </div>
      <h2 class="mobileHeading d-none d-md-block">Communications</h2>
    </div>
  </nav>
  <div class="row mt-3">
    <div class="col-12 mb-3">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="'CONVERSATION'">
        <!-- Conversation -->
        <li ngbNavItem="CONVERSATION">
          <a ngbNavLink>Conversations
            <span class="badge bg-danger" *ngIf="badgeCount && badgeCount > 0">{{ badgeCount }}</span>
          </a>
          <ng-template ngbNavContent>
            <app-conversation (totalUnread)="triggerUnreadCount($event)"></app-conversation>
          </ng-template>
        </li>
        <!-- Call History -->
        <li ngbNavItem="CALLHISTORY">
          <a ngbNavLink>Call History</a>
          <ng-template ngbNavContent>
            <app-call-history></app-call-history>
          </ng-template>
        </li>
        <!-- Voicemails -->
        <li ngbNavItem="VOICEMAILS">
          <a ngbNavLink>Voicemails</a>
          <ng-template ngbNavContent>
            <app-voice-mails></app-voice-mails>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>
</div>

<ngx-spinner>
  <p class="loading-spinner">Loading...</p>
</ngx-spinner>

<ng-template #redirectInstruction>
  <div class="row text-center w-100 align-content-center">
    <h5 *ngIf="login.role != 'USER'; else commDisabled">
      Configure SMS/Calls in Settings to enable Communication features.
      <br />
      <button type="button" class="btn btn-primary mt-4" (click)="redirectToSettings();">
        <!-- <fa-icon class="button-icon-left" [icon]="faSave"></fa-icon> -->
        <span>Go to Settings</span>
      </button>
    </h5>
    <ng-template #commDisabled>
      <h5>
        Communication tab is disabled. Contact your Administrator.
      </h5>
    </ng-template>
  </div>
</ng-template>
